module.exports = __webpack_public_path__ + "public/Icons/languageIcon.svg?d61fe0d7";